export default __webpack_public_path__ + "static/media/Sweet-1.d31566d8.jpg";